export const referHospitalCreateTranslations = {
    en: {
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        submitSuccess: "Hospital details sent successfully for OPD",
        submitFailed: "Failed to send hospital details",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No eg. 00005",
        beneficiaryName: "Beneficiary Name",
        date: "Date",
        remarks: "Remarks",
        remarksPlaceholder: "Enter Remarks",

        selectedHospitals: "Selected Hospitals",
        hospitals: "Hospitals",
        pincode: "Pincode",
        sendInformation: "Generate Letter"
    },
    mr: {
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        submitSuccess: "ओपीडी साठी रुग्णालय तपशील यशस्वीरित्या पाठवले",
        submitFailed: "रुग्णालय तपशील पाठवण्यात अयशस्वी",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        date: "तारीख",
        remarks: "शेरा",
        remarksPlaceholder: "शेरा प्रविष्ट करा",

        selectedHospitals: "निवडलेली रुग्णालये",
        hospitals: "रुग्णालये",
        pincode: "पिन कोड",
        sendInformation: "माहिती पाठवा"
    }
};
